import { createFileRoute } from '@tanstack/react-router';
import { AccountLedgerView } from '../../features/accounting/components/AccountLedgerView';
import { usePageTitle } from '../../lib/hooks.js';

export const Route = createFileRoute('/_auth/ledger/$accountId')({
  component: LedgerPage,
});

function LedgerPage() {
  usePageTitle('Account Ledger');
  return (
    <div>
      <AccountLedgerView />
    </div>
  );
}
